<input type="hidden" id="medicalTourismTrigger" data-toggle="modal" data-target="#medicalTourismPopup">

<!-- The Modal -->
<div class="modal fade" id="medicalTourismPopup">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Medical Tourism</h5>
      </div>
      <!-- Modal body -->

      <div class="modal-body">
        <div class="sign-up-form add-doc-form">
          <div class="add-doc-ambu-cmn add-treat-form">
            <!-- <h2> What would you like to Add? </h2> -->
            <form #medical="ngForm" class="doctors-edit-main p-0 no-shadow">
              <div class="doctors-edit-lft">
                <div class="edit-profile-form-rows">
                  <div class="row no-gutters">
                    <!-- <div class="col-md-12">
                        <label> Name </label>
                        <input type="text" name="tourismName" [(ngModel)]="tourism.name" class="form-control" placeholder="Name">
                    </div> -->
                    <div class="col-md-12">
                      <label> Phone No </label>
                      <br>
                      <input type="text" required ng2TelInput [ng2TelInputOptions]="{initialCountry: 'in'}"
                             (hasError)="hasError($event)" minlength="10" maxlength="10" ng2TelInput
                             [ng2TelInputOptions]="{initialCountry: 'in'}"
                             (hasError)="hasError($event)" minlength="10" maxlength="10"
                             class="form-control" (keypress)="numberOnly($event,null)" [(ngModel)]="tourism.phoneNo"
                             name="phoneNo"
                             #phoneNo="ngModel"
                             (countryChange)="onCountryChangeTourism($event)"
                             style="padding-left: 70px;"
                      >
                        <div *ngIf="medical.submitted && !phoneNo.value" class="alert alert-danger" >Phone No. is required</div> 
                    </div>
                    <div class="col-md-12">
                      <label> Upload Medical Record </label>
                      <br>
                      <input type="file" (change)="fileChanged($event)" style="display:none;" #tourismFile
                             class="form-control" name="treatmentRecord" accept="image/*">
                      <button type="button" (click)="tourismFile.click()" class="btn btn-primary">Upload</button>
                      <img *ngFor="let record of tourism.medicalRecords" width="60px" height="60px" [src]="record"
                      style="margin-left: 30px;">
                      <div *ngIf="medical.submitted && tourism.medicalRecords.length==0" class="alert alert-danger" >Please select an image to Upload</div> 
                    </div>
                   
                    <div class="col-md-12">
                      <label> Subject </label>
                      <input required type="text" class="form-control" name="treatmentSubject" placeholder="Enter Subject"
                             [(ngModel)]="tourism.subject" #subject="ngModel">
                             <div *ngIf="medical.submitted && !subject.valid" class="alert alert-danger" >Please Enter Subject</div> 
                    </div>
                    <div class="col-md-12">
                      <label> Description </label>
                      <textarea required class="form-control" name="treatmentDescription" placeholder="Enter Description"
                                [(ngModel)]="tourism.description" #description="ngModel"></textarea>
                                <div *ngIf="medical.submitted && !description.valid" class="alert alert-danger" >Please Enter Description</div> 
                    </div>
                    <div class="col-md-12">
                      <div class="add-doc-btns-btm mt-3">
                    <button type="submit" (click)="uploadTourism(medical)"   class="btn-style no-shadow"> Save </button>
                        <button type="button"  class="btn-style-grey  no-shadow" data-dismiss="modal" (click)="resetForm(medical)"> Cancel </button> 
                        <!-- <a [routerLink]="null"   class="btn-style no-shadow"> Save </a>
                        <a href="javascript://" class="btn-style btn-style-grey  no-shadow" data-dismiss="modal"> Cancel </a> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>


    </div>
  </div>
</div>
